import { Grid, Box, Stack } from '@mui/material'
import ReaderHelpIcon, { ReaderHelpIconProps } from 'components/ReaderHelpIcon'
import { ReactNode } from 'react'

interface Props {
  title: string
  readerHelpIconProps?: ReaderHelpIconProps
  description: string
  padding?: boolean
  children: ReactNode
}

const TabContent = (props: Props) => {
  const { title, readerHelpIconProps, description, padding = false, children } = props

  return (
    <Grid container spacing={4} px={0} py={2}>
      <Grid item xs={2}>
        <Stack direction="row" alignItems="start">
          <h2>{title}</h2>
          {readerHelpIconProps && (
            <Box sx={{ my: 1.6 }}>
              <ReaderHelpIcon
                builderPath={readerHelpIconProps.builderPath}
                concurPath={readerHelpIconProps.concurPath}
                invoicePath={readerHelpIconProps.invoicePath}
                orderFormPath={readerHelpIconProps.orderFormPath}
              />
            </Box>
          )}
        </Stack>
        <p>{description}</p>
      </Grid>
      <Grid item xs={8}>
        <Box p={padding ? 2 : 0}>{children}</Box>
      </Grid>
    </Grid>
  )
}

export default TabContent
